import { Component, OnInit, Output, EventEmitter, Input, OnChanges, SimpleChanges } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';

import { AuthService } from './../../../../../services/auth.service';
import { MemberService } from './../../../../../rest/api/member.service';
import { HelperService } from './../../../../../services/helper.service';

import _ from 'lodash';
import { InternalFormsSharedModule } from '@angular/forms/src/directives';
@Component({
  selector: 'app-add-title',
  templateUrl: './add-title.component.html',
  styleUrls: ['./add-title.component.scss']
})
export class AddTitleComponent implements OnInit, OnChanges {
  @Input() currentTextMesh;
  @Input() editHotspots;
  @Input() videoTime;
  @Input() selectedMedia;

  @Output() inputChangeEmit = new EventEmitter();
  @Output() createHotspotEmit = new EventEmitter();
  @Output() deleteHotspotEmit = new EventEmitter();
  @Output() updateHotspotEmit = new EventEmitter();
  @Output() closeHotSpotBoxEmit = new EventEmitter();
  @Output() changeColorEmit = new EventEmitter();


  createHotspotForm: FormGroup;
  accessToken: any;
  isSubmitting = false;
  isSubmitted = false;

  errors = [];
  successMsg: string;
  errorMsg: string;

  constructor(
    public fb: FormBuilder,
    private authService: AuthService,
    public memberService: MemberService,
    public helperService: HelperService,
  ) {
    this.accessToken = `Bearer ${this.authService.getAccessToken()}`;
    this.createHotspotsFormInit();
  }

  ngOnInit() {
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes && changes.editHotspots) {
      if (changes.editHotspots.currentValue) {
        this.resetFormValues(changes.editHotspots.currentValue);
      } else {
        this.resetFormValues(undefined);
      }
    }
  }

  createHotspotsFormInit() {
    this.createHotspotForm = this.fb.group({
      title: ['', [Validators.required]],
      color: ['#008080', [Validators.required]],
    });
  }

  submit(value) {
    if (!this.createHotspotForm.valid) {
      this.isSubmitting = true;
      return;
    }
    if (this.isSubmitted) {
      return;
    }
    this.isSubmitted = true;
    this.resetErrors();
    const data = value;
    data.type = 'video';
    data.coordinates = this.currentTextMesh.position;
    data.media_id = this.selectedMedia.uuid;
    if (this.editHotspots) {
      data.time = this.editHotspots.time ? this.editHotspots.time : this.videoTime;
      this.updateHotspots(data);
    } else {
      data.time = this.videoTime;
      this.createHotspots(data);
    }
  }

  resetErrors() {
    this.errorMsg = undefined;
    this.errors = [];
  }

  createHotspots(data) {
    let formData;
    formData = data;
    formData = this.helperService.updateJsonFormat(formData);
    this.memberService.createHotspot({
      Authorization: this.accessToken,
      body: formData
    }).subscribe((response: any) => {
      this.resetForm();
      this.successMsg = 'New hotspot was successfuly created.';
      setTimeout(() => {
        this.resetErrorValues();
        const responseData = response && response.data ? response.data : undefined;
        this.createHotspotEmit.emit(responseData);
      }, 2000);
    }, err => {
      this.handleErrors(err);
    });
  }

  updateHotspots(data) {
    let formData;
    formData = data;
    formData = this.helperService.updateJsonFormat(formData);
    this.memberService.updateHotspot({
      Authorization: this.accessToken,
      id: this.editHotspots.uuid,
      body: formData
    }).subscribe((response: any) => {
      this.resetForm();
      this.successMsg = 'Hotspot was successfuly updated.';
      setTimeout(() => {
        this.resetErrorValues();
        const responseData = response && response.data ? response.data : undefined;
        this.updateHotspotEmit.emit(responseData);
      }, 2000);
    }, err => {
      this.handleErrors(err);
    });
  }

  resetForm() {
    this.isSubmitted = false;
    this.isSubmitting = false;
    this.resetFormValues(undefined);
  }

  resetFormValues(data) {
    if (!data) {
      this.createHotspotForm.reset({
        title: '',
        color: '#ffc378'
      });
    } else {
      this.createHotspotForm.reset({
        title: data.title,
        color: data.color && data.color !== '' ? data.color : '#ffc378'
      });
    }
  }

  handleErrors(err) {
    if (err.error && err.error.errors) {
      this.errors = err.error.errors;
    } else if (err.error && err.error.error) {
      this.errorMsg = err.error.error;
    } else {
      this.errorMsg = 'There was error while creating hotspot.';
    }
    this.isSubmitted = false;
    this.isSubmitting = false;
    setTimeout(() => {
      this.resetErrors();
    }, 5000);
  }

  resetErrorValues() {
    this.isSubmitted = false;
    this.errorMsg = undefined;
    this.successMsg = undefined;
    this.isSubmitting = false;
    this.isSubmitted = false;
  }

  deleteHotspot() {
    this.deleteHotspotEmit.emit('link');
  }

  modalCloseEmit(hotspot) {
    if ($('#deleteModal')) {
      $('#deleteModal').modal('hide');
    }
    if (hotspot) {
      this.deleteHotspotEmit.emit(hotspot);
    }
  }

  inputChange(value) {
    this.inputChangeEmit.emit(value);
  }

  closeHotSpotBox() {
    this.closeHotSpotBoxEmit.emit(true);
  }

  changeColor(color) {
    this.changeColorEmit.emit(color);
  }

}
